export const getPageDataFromUrl = (
	url: string,
): {
	spaceKey: string;
	contentType: string;
	contentId: string;
} => {
	/* Extracting Confluence page data from URL because we don't have access to the page context
	 * from the Screen Space Flags placement.
	 *
	 * Sample page URL: wiki/spaces/{spaceKey}/pages/{contentId}/This+is+the+title+of+a+page
	 * Sample blog URL: wiki/spaces/{spaceKey}/blog/2025/04/11/{contentId}/This+is+the+title+of+a+blog+post
	 */
	const [, spaceKey, rawContentType, contentId] =
		url.match(
			/\/wiki\/spaces\/([^/]+)\/(pages|blog|whiteboard|database)(?:\/\d{4}\/\d{2}\/\d{2})?\/(?:edit-v2\/)?([^/]+)/,
		) || [];

	const contentType =
		rawContentType === 'pages' ? 'page' : rawContentType === 'blog' ? 'blogpost' : rawContentType;

	return {
		spaceKey,
		contentType,
		contentId,
	};
};
